import { render, staticRenderFns } from "./SnsDashboard.vue?vue&type=template&id=84427b0a&"
import script from "./SnsDashboard.vue?vue&type=script&lang=js&"
export * from "./SnsDashboard.vue?vue&type=script&lang=js&"
import style0 from "./SnsDashboard.vue?vue&type=style&index=0&id=84427b0a&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports